import { render, staticRenderFns } from "./EmotionIcon.vue?vue&type=template&id=0eaa1e5b"
import script from "./emotion-icon.ts?vue&type=script&lang=ts&external"
export * from "./emotion-icon.ts?vue&type=script&lang=ts&external"
import style0 from "./emotion-icon.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports